"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
exports.escapeRegexp = escapeRegexp;



//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ng2-select/select/common.js
// module id = ../../../../ng2-select/select/common.js
// module chunks = 4